var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 32,
    viewBox: "0 0 54 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9206 28.1777C24.0692 30.5611 20.3705 32 16.3288 32C7.31064 32 0 24.8366 0 16C0 7.16344 7.31064 0 16.3288 0C20.3705 0 24.0692 1.43886 26.9206 3.82232C29.7719 1.43886 33.4707 0 37.5124 0C46.5305 0 53.8411 7.16344 53.8411 16C53.8411 24.8366 46.5305 32 37.5124 32C33.4707 32 29.7719 30.5611 26.9206 28.1777Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9189 28.1761C30.4286 25.2414 32.654 20.8753 32.654 16C32.654 11.1247 30.4286 6.75862 26.9189 3.82394C29.7706 1.43951 33.4701 0 37.5127 0C46.5308 0 53.8415 7.16344 53.8415 16C53.8415 24.8366 46.5308 32 37.5127 32C33.4701 32 29.7706 30.5605 26.9189 28.1761Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9245 28.1777C23.4137 25.243 21.1875 20.8762 21.1875 16C21.1875 11.1237 23.4137 6.75699 26.9245 3.8223C30.4353 6.75699 32.6614 11.1237 32.6614 16C32.6614 20.8762 30.4353 25.243 26.9245 28.1777Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment5);
export default __webpack_public_path__ + "static/media/payment5.68385471ca4f0c8d3931d4659c74a7cf.svg";
export { ForwardRef as ReactComponent };